<template>
  <el-dialog :class="[currentTheme]" :title="dialogName" :visible.sync="dialogVisible" top="80px" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" width="1200px">
    <div class="main-box">
      <xr-data-table ref="xrTable" :configure="configure"></xr-data-table>
    </div>
    <message-info-dialog ref="messageInfoDialog" v-if="isMessageInfoShow" @closeDialog="closeDialog"></message-info-dialog>
  </el-dialog>
</template>

<script>
  import MessageInfoDialog from "./message-info-dialog";
  export default {
    name: "messageListDialog",
    data (){
      return {
        // calculationMethodList:[],
        // surchargeTypeList:[],
        dialogName: '查看信息列表',
        dialogVisible: false,
        isMessageInfoShow: false, //是否显示详情
        configure: {
          listParam: {
            testMethodId: '-1',
            itemGroupIds: ''
          },
          url: '/web/service?method=tMetalSendMessage_list',
          isShowSearch: false,
          defaultNoLoadData: true,
          pagination: true, //允许分页（默认true）
          isSelectFirst: false,
          idField: 'id',
          tableHeight: 570,
          that: this,
          columns: [
            {
              field: 'sn',
              width: 60,
            },
            {
              field: 'title',
              title: '标题',
              width: 130,
              condition: {
                searchType: 'input',
                searchName: 'titleSearch',
              },

            },
            {
              field: 'content',
              title: '内容',

              condition: {
                searchType: 'input',
                searchName: 'contentSearch',
              }
            },
            {
              field: 'status',
              title: '状态',
              width: 85,
              condition: {
                searchType: 'select',
                searchName: 'statusSearch',
                value:'',
                selectList:[
                  {value: '',label: ''},
                  {value: '0',label: '未读'},
                  {value: '1',label: '已读'},
                ]
              },
              align:'center'
            },
            {
              field: 'createdTime',
              title: '创建时间',
              width: 150,
              condition: {
                searchType: 'input',
                searchName: 'createdTimeSearch',
              },
              align:'center'
            },
            {
              field: 'operate',
              title: '操作',
              width: 150,
              cellType: 'operate',
              that: this,
              operateList: [
                // {
                //   text: '查看',
                //   that: this,
                //   handler: function (row) {
                //     this.that.viewInfo(row.id);
                //   }
                // },
                {
                  text: '设为已读',
                  that: this,
                  display: function(row){
                    if(row.status == '0'){
                      return true;
                    }
                    return false;
                  },
                  handler: function (row) {
                    this.that.setReadOne(row.id);
                  }
                },
              ]
            }

          ],
          toolbar: [
            {
              text: '全部已读',
              iconCls: 'wk wk-message-read',
              that: this,
              handler: function () {
                this.that.setReadAll();
              }
            }
          ],
          tableData:[   //数据列表
            // {
            //   'id':'1',
            //   'title':'权益到期提醒',
            //   'content':'您的权益将于2025年9月19日24时到期，为了避免正常使用，请及时续费购买!',
            //   'status':'1',
            //   'createdTime':'2025-09-19 13:00:00'
            // },
            // {
            //   'id':'2',
            //   'title':'订单待接收提醒',
            //   'content':'您有一个待接收的订单，请及时处理',
            //   'status':'0',
            //   'createdTime':'2025-09-20 16:23:00'
            // }
          ]
        },
      }
    },
    computed: {
      orgCategory() {
        return this.$store.getters.orgCategory; //获取机构类型
      },
      orgId() {
        return this.$store.getters.orgId; //获取机构id
      },
      orgName() {
        return this.$store.getters.orgName; //获取机构名称
      },
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    components: {
      MessageInfoDialog
    },
    created(){

    },
    methods: {
      init() {
        this.dialogVisible = true
        this.$nextTick(()=>{
          this.$refs.xrTable.getData();
        })
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
      },
      //设置已读
      setRead(){
        const list = this.$refs.xrTable.multipleSelection;
        if(list.length < 1 ){
          this.$message.warning("请选择需要设置为已读的消息")
          return false;
        }
        const ids = list.join(',')
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tMetalSendMessage_setRead',
            ids: ids,
            type:'def'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$refs.xrTable.getData();
              // 重新获取未读数字
              this.$emit('getUnreadNum')
            }
          })
        })
      },
      //设置全部已读
      setReadAll(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tMetalSendMessage_setRead',
            type:'all'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$refs.xrTable.getData();
              // 重新获取未读数字
              this.$emit('getUnreadNum')
            }
          })
        })
      },

      //设置一条已读
      setReadOne(id){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tMetalSendMessage_setRead',
            ids: id,
            type:'def'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$refs.xrTable.getData();
              // 重新获取未读数字
              this.$emit('getUnreadNum')
            }
          })
        })
      },

      //设置一条已读(详情页)
      setReadOneByView(id){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tMetalSendMessage_setRead',
            ids: id,
            type:'def'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$refs.xrTable.getData();
          // 重新获取未读数字
          this.$emit('getUnreadNum')
        })
      },
      // 查看详情
      viewInfo(id){
        this.isMessageInfoShow = true;
        this.$nextTick(()=>{
          this.$refs.messageInfoDialog.init(id);
        })
        this.setReadOneByView(id);

      },
      // 关闭弹窗
      closeDialog(){
        this.dialogVisible = false
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/views/base/message/message-list-dialog.vue